export default "__VITE_PUBLIC_ASSET__fbbc881e__"